import React, { useCallback } from 'react'
import { TextField, Box } from '@mui/material'
import { FieldInputProps } from '../../types'
import { getFieldStyles } from '../../utils/fieldStyles'
import { CopyButton } from '../CopyButton'

export const NumberInput: React.FC<FieldInputProps> = React.memo(
	({
		field,
		value,
		onChange,
		error,
		compact = false,
		isMobile = false,
		showCopyButton = false,
	}) => {
		const styles = getFieldStyles(compact, isMobile)

		// Оптимизированный обработчик изменений - без debounce для мгновенного отклика
		const handleChange = useCallback(
			(e: React.ChangeEvent<HTMLInputElement>) => {
				// Передаем сырое значение, чтобы можно было вводить "0." и "0,"
				// Валидация и преобразование в число должны происходить при сабмите или в родительском компоненте
				const raw = e.target.value
				// Пропускаем только числовой ввод: цифры, необязательный минус,
				// один десятичный разделитель (точка или запятая)
				if (raw === '' || /^-?\d*[.,]?\d*$/.test(raw)) {
					onChange(field.name, raw)
				}
			},
			[field.name, onChange]
		)

		return (
			<Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
				<TextField
					fullWidth
					id={field.name}
					name={field.name}
					label={field.label}
					// type="text" вместо "number": у number-полей скролл колесом меняет
					// значение при фокусе, а стрелки-спиннеры не нужны пользователям
					type='text'
					slotProps={{ htmlInput: { inputMode: 'decimal' } }}
					margin={compact || isMobile ? 'dense' : 'normal'}
					size={isMobile ? 'small' : compact ? 'small' : 'medium'}
					value={value || ''}
					onChange={handleChange}
					error={!!error}
					helperText={error}
					required={field.required}
					sx={styles.textField}
				/>
				{showCopyButton && (
					<CopyButton value={value} compact={compact} isMobile={isMobile} />
				)}
			</Box>
		)
	}
)
